module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/efo_features_07-549b5b93a5867097d0664bc535d7122e.png";